const others = [
  ["", "AREA1", "LA VOLUME", "LVEDD", "LV MASS"],
  ["4C", "AREA2", "LAVI", "IVSd", "LV MASS INDEX"],
  ["4C", "LENGTH", "", "PWD", "SEVERITY BY LVMI"],
  ["2C", "HEIGHT", "", "HEIGHT", "RWT"],
  ["2C", "WEIGHT", "BSA", "WEIGHT", "GEOMETRY BY RWT"],
];

export default others;
